interface IconPropsInterface {
    width?: number;
    height?: number;
    fill?: string;
    stroke?: string;
}

const FourCircleSvg = (props: IconPropsInterface) => {
    return (
        <svg
            width={props.width ?? '24'}
            height={props.height ?? '24'}
            viewBox="0 0 24 24"
            fill={props.fill ?? 'none'}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.125 10.5C8.98896 10.5 10.5 8.98896 10.5 7.125C10.5 5.26104 8.98896 3.75 7.125 3.75C5.26104 3.75 3.75 5.26104 3.75 7.125C3.75 8.98896 5.26104 10.5 7.125 10.5Z"
                stroke={props.stroke ?? "#B3B3B3"}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.875 10.5C18.739 10.5 20.25 8.98896 20.25 7.125C20.25 5.26104 18.739 3.75 16.875 3.75C15.011 3.75 13.5 5.26104 13.5 7.125C13.5 8.98896 15.011 10.5 16.875 10.5Z"
                stroke={props.stroke ?? "#B3B3B3"}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.125 20.25C8.98896 20.25 10.5 18.739 10.5 16.875C10.5 15.011 8.98896 13.5 7.125 13.5C5.26104 13.5 3.75 15.011 3.75 16.875C3.75 18.739 5.26104 20.25 7.125 20.25Z"
                stroke={props.stroke ?? "#B3B3B3"}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.875 20.25C18.739 20.25 20.25 18.739 20.25 16.875C20.25 15.011 18.739 13.5 16.875 13.5C15.011 13.5 13.5 15.011 13.5 16.875C13.5 18.739 15.011 20.25 16.875 20.25Z"
                stroke={props.stroke ?? "#B3B3B3"}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default FourCircleSvg;
